// services
import { AxiosInstance } from 'axios';
import AxiosInstanceCreator from 'services/api';

// models
import { BaseApiResponse } from 'modules';
import { ReqLogin, ResLogin } from 'domains/Auth';
import { ReqCheckPkg } from '../models/check';
import { ReqSignUpSettings, ResSignUpSettings } from '../models/info';
import { ReqCreateSignUp, ResCreateSignUp } from '../models/register';
import { ReqOtp, ResOtp } from '../models/otp';

export class PkgAPI {
  Axios: AxiosInstance;

  constructor() {
    this.Axios = new AxiosInstanceCreator().create();
  }

  async checkPkgUser(request: ReqCheckPkg): Promise<BaseApiResponse<boolean, unknown>> {
    return this.Axios.get(`/pkg/check`, { params: request }).then((res) => res.data);
  }

  async fetchSettings(request: ReqSignUpSettings): Promise<ResSignUpSettings> {
    return this.Axios.get(`/pkg/info`, { params: request }).then((res) => res.data);
  }

  async createSignUp(request: ReqCreateSignUp): Promise<ResCreateSignUp> {
    return this.Axios.post(`/pkg/register`, request).then((res) => res.data);
  }

  async fetchOtp(request: ReqOtp): Promise<ResOtp> {
    return this.Axios.get(`/pkg/key`, { params: request }).then((res) => res.data);
  }
}
